import { FCX } from "@datassential/platform-ui-lib";
import { SelectSingle } from "@components/Select";
import { useMemo } from "react";
import { HomeViewAs } from "@core/constants";
import { useHomeContext, useHomeSearchSettingsContext } from "@pages/Home/HomeContext";

const SelectViewAs: FCX = () => {
    const { viewAs, setViewAs } = useHomeContext();
    const { resetSearch } = useHomeSearchSettingsContext();

    const viewOptions = useMemo(
        () => {
            return [HomeViewAs.Tile, HomeViewAs.Table, HomeViewAs.Brands, HomeViewAs.People, HomeViewAs.Gain, HomeViewAs.Trend]
                .map((i) => ({
                    id: i,
                    title: i,
                }));
        },
        []
    );

    return (
        <SelectSingle
            className="HomeHeaderControls"
            value={viewAs}
            setValue={setViewAs}
            options={viewOptions}
            label="VIEW AS:"
            testId="selectSearchHeaderViewAs"
            onChange={resetSearch}
        />
    );
}

export default SelectViewAs;